module.exports = __webpack_public_path__ + "img/5.e31a0710.png";